import { HandleReturnItemChange } from 'components/Orders/Order';
import { BuyOutDecision, ReturnItem, ReturnOrderLine } from 'returnCenter-api';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { StyledSelect } from './RefundCell';
import Flex from 'components/ui/Flex';
import { styled } from 'styled-components';

type BuyOutDecisionCellProps = {
    item: ReturnItem;
    itemId?: number | string;
    handleReturnItemChange: HandleReturnItemChange;
    orderline?: ReturnOrderLine;
    disabled?: boolean;
};

/** Deliberately starts empty, no default: the credit stays blocked until the operator chooses. */
const BuyOutDecisionCell = ({
    item,
    itemId,
    handleReturnItemChange,
    orderline,
    disabled = false,
}: BuyOutDecisionCellProps) => {
    const { t } = useTranslation();
    const [menuOpen, setMenuOpen] = useState(false);

    const options = useMemo(
        () => [
            { value: BuyOutDecision.Buy, label: t('buyOut.buy', 'Buy') },
            { value: BuyOutDecision.NoAction, label: t('buyOut.noAction', 'Leave it') },
        ],
        [t],
    );

    const currentValue = useMemo(() => {
        const decision = item.buyOutDecision;
        if (decision === null || decision === undefined) return null;
        return options.find((option) => option.value === decision) ?? null;
    }, [options, item.buyOutDecision]);

    return (
        <Wrapper $grow={1} align="center" gap="0.5rem">
            <StyledSelect
                isDisabled={disabled}
                data-item-id={itemId}
                key={itemId}
                menuIsOpen={menuOpen}
                onMenuOpen={() => setMenuOpen(true)}
                onMenuClose={() => setMenuOpen(false)}
                value={currentValue}
                placeholder={t('buyOut.undecided', 'Not decided')}
                options={options}
                onChange={(selected: any) =>
                    handleReturnItemChange(
                        orderline?.orderNumber ?? '',
                        orderline?.sku ?? '',
                        orderline?.orderLineNumber ?? '',
                        itemId ?? -1,
                        'buyOutDecision',
                        (selected as { value: BuyOutDecision }).value,
                    )
                }
            />
        </Wrapper>
    );
};

export default BuyOutDecisionCell;

const Wrapper = styled(Flex)`
    min-width: 9rem;
`;
